// All Auvious action buttons
const auviousActionEls = document.getElementsByClassName('auviousCard__action');

// Auvious widget options
let widgetOptions = {
  'locale': 'en-US',
  'pc-environment': 'usw2.pure.cloud',
  'pc-organization-id': '9b2fbe10-dc92-4888-b334-c7b73751bc29',
  'application-id': '044fff75-84c2-4584-9fb9-fd07dc5dba89',
  'chat-mode' : 'genesys-web-messaging',
  'auvious-environment': 'us.auvious.video',
  'customer-display-name': 'In-Branch Member',
  'kiosk-mode': 'true'
};

// Enables/disables call buttons. Prevents user from attempting to activate multiple calls
function enableCallButtons(enabled = true, except = null) {
  const elsToChange = Array.from(auviousActionEls).filter(el => el != except);

  if (enabled) {
    elsToChange.forEach(el => {
      el.removeAttribute('disabled');
      el.classList.remove('-inactive');
    });
  } else {
    elsToChange.forEach(el => {
      el.setAttribute('disabled', true);
      el.classList.add('-inactive');
    });
  }
}

function removeWidgetIfExists() {
  const widget = document.getElementById('auvious-widget');
  if (widget) {
    widget.remove();
  }
}

async function createWidget(deploymentId, queue) {
  if (customElements.get('app-auvious-widget') === undefined) {
    // Auvious is not ready yet
    return;
  }

  // Destroy existing widget
  removeWidgetIfExists();

  // Create new widget
  const widget = document.createElement('app-auvious-widget');
  widget.setAttribute('id', 'auvious-widget');

  // Hide widget initially
  widget.setAttribute('style', 'display:none');

  // Get all the widget options and pass it to our widget.
  Object.keys(widgetOptions).forEach(key => {
    const value = widgetOptions[key];
    widget.setAttribute(key, value);
  });

  // Set deployment ID and queue on widget
  widget.setAttribute('pc-deployment-id', deploymentId);
  widget.setAttribute('pc-queue', queue);

  widget.addEventListener('callStarting', e => {
    // show widget
    const widget = document.getElementById('auvious-widget');
    widget.setAttribute('style', 'display:block');
  });

  widget.addEventListener('callEnded', e => {
    // hide widget
    const widget = document.getElementById('auvious-widget');
    widget.setAttribute('style', 'display:none');
    enableCallButtons();
  });

  widget.addEventListener('conversationEnded', () => {
    // hide widget
    const widget = document.getElementById('auvious-widget');
    widget.setAttribute('style', 'display:none');
    enableCallButtons();
  });

  // add the newly created widget to the body.
  document.body.appendChild(widget);
}

// To change deployment ID, we swap out the widget entirely
function startCall(deploymentId, queue) {
  createWidget(deploymentId, queue);
  
  // Show widget now
  const widget = document.getElementById('auvious-widget');
  widget.setAttribute('style', 'display:block');

  if (widget) {
    enableCallButtons(false, widget);
    widget.launch('video');
  }
}

// Register click actions for Auvious call buttons
if (auviousActionEls) {
  for(var action of auviousActionEls) {
    const deploymentId = action.dataset.deploymentId;
    const queue = action.dataset.queue;

    if (deploymentId && queue) {
      action.addEventListener('click', () => startCall(deploymentId, queue));
    }
  }
}
